import { ALTERAR_REGISTROS_POR_PAGINA_ROTA_ITINERARIO } from '../types'

export default function alterarRegistrosPorPaginaRotas (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_ROTA_ITINERARIO,
    payload: valor
  }
}